import { useEffect, useRef } from "react";

// AIDEV-NOTE: Paths whose page component POSTs its own /api/page-view row so
// it can attach experiment metadata. PageViewTracker skips these to avoid
// double-counting — keep the two in sync.
// AIDEV-NOTE: /account/billing now redirects to /account/membership (BACKEND-6AD), so the
// page only mounts there; the billing entry is kept as a harmless legacy guard.
export const SELF_REPORTED_PAGE_VIEW_PATHS = [
    "/account/membership",
    "/account/billing",
];

/**
 * Log one page view for the current path, carrying experiment exposure
 * metadata. Fires once per mount; safe to call on every render.
 */
export function useSelfReportedPageView(metadata: {
    experiment: string;
    variant: string;
    state?: string;
}) {
    const sentRef = useRef(false);

    useEffect(() => {
        if (sentRef.current) return;
        sentRef.current = true;

        void fetch("/api/page-view", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                path: window.location.pathname,
                referrer: document.referrer || null,
                metadata,
            }),
        }).catch(() => {
            // Analytics must never break the page.
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
